export const environment = {
  production: true,
  serverUrl: 'api/v1/',
  dadataToken: 'Token ccb1e869656ee2ab24922f540672bda545149313',
  modules: []
};
